import { clearSession, storeProfile, storeSession } from "../../util/adminSession";

import { SET_ADMIN, UNSET_ADMIN, UPDATE_PROFILE } from "./types";

const initialState = {
  isAuth: false,
  admin: {},
};

const profileOf = (admin = {}) => ({
  _id: admin._id,
  name: admin.name,
  email: admin.email,
  username: admin.username,
  image: admin.image,
  flag: admin.flag,
});

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    // payload: { token, admin } from /admin/auth/mfa or a restored session
    case SET_ADMIN: {
      const admin = profileOf(action.payload?.admin);
      storeSession(action.payload.token, admin);
      return {
        ...state,
        isAuth: true,
        admin,
      };
    }

    case UNSET_ADMIN:
      clearSession();
      localStorage.removeItem("firstLoad");
      localStorage.removeItem("CategoryDetail");
      localStorage.removeItem("CategoryId");
      localStorage.removeItem("PostDetail");
      localStorage.removeItem("VideoDetail");
      return {
        ...state,
        isAuth: false,
        admin: {},
      };

    case UPDATE_PROFILE: {
      const admin = profileOf({ ...state.admin, ...action.payload });
      storeProfile(admin);
      return {
        ...state,
        admin,
      };
    }
    default:
      return state;
  }
};

export default adminReducer;
